import {IActivityState, initialActivityState} from '@app/core/store/state/activity.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {ActivityActions, EActivityActions} from '@app/core/store/actions/activity.actions';
import {EEmployeesActions, EmployeesActions} from '@app/core/store/actions/employees.actions';
import {EScheduleActions, ScheduleActions} from '@app/core/store/actions/schedule.actions';

export const activityReducers = (
	state = initialActivityState,
	action: ActivityActions | ErrorActions | EmployeesActions | ScheduleActions,
): IActivityState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EActivityActions.GetActivities: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EActivityActions.GetActivity: {
			return {
				...state,
				isLoadingActivity: true,
			};
		}
		case EActivityActions.GetRelationActivity: {
			return {
				...state,
				isLoadingRelationActivity: true,
			};
		}
		case EActivityActions.GetRelationActivitySuccess: {
			const activities = [...state.activities, ...action.activities];
			activities.sort((a, b) => b.created_at.localDate.toDate().valueOf() - a.created_at.localDate.toDate().valueOf());
			return {
				...state,
				activities,
				isLoadingRelationActivity: false,
				pagination: action.pagination,
			};
		}
		case EActivityActions.GetActivitiesSuccess: {
			const activities = [...state.activities, ...action.activities];
			activities.sort((a, b) => b.created_at.localDate.toDate().valueOf() - a.created_at.localDate.toDate().valueOf());
			return {
				...state,
				activities,
				isLoading: false,
				pagination: action.pagination,
			};
		}
		case EActivityActions.GetActivitySuccess: {
			return {
				...state,
				isLoadingActivity: false,
				activity: action.activity
			};
		}
		case EScheduleActions.GetUsersSuccess:
		case EEmployeesActions.GetUsersSuccess: {
			const newUsers = {
				...state.users
			};
			action.users.forEach(u => newUsers[u.id] = u);
			return {
				...state,
				users: newUsers
			};
		}
		case EEmployeesActions.GetUserSuccess: {
			const newUsers = {
				...state.users
			};
			newUsers[action.user.id] = action.user;
			return {
				...state,
				users: newUsers
			};
		}
		case EScheduleActions.GetGroupsSuccess:
		case EEmployeesActions.GetGroupsSuccess: {
			const newGroups = {
				...state.groups
			};
			action.groups.forEach(u => newGroups[u.id] = u);
			return {
				...state,
				groups: newGroups
			};
		}
		case EEmployeesActions.GetGroupSuccess: {
			const newGroups = {
				...state.groups
			};
			newGroups[action.group.id] = action.group;
			return {
				...state,
				groups: newGroups
			};
		}
		case EActivityActions.SetActivities: {
			return {
				...state,
				activities: action.activities,
			};
		}
		default:
			return state;
	}
};
